import { useContext, createContext } from 'react'

export const varHover = (hover = 1.09, tap = 0.97) => ({
    hover: { scale: hover },
    tap: { scale: tap },
})

export function localStorageAvailable() {
    try {
        const key = '__some_random_key_you_are_not_going_to_use__'
        window.localStorage.setItem(key, key)
        window.localStorage.removeItem(key)
        return true
    } catch (error) {
        return false
    }
}

export function localStorageGetItem(key: string, defaultValue = '') {
    const storageAvailable = localStorageAvailable()

    let value

    if (storageAvailable) {
        value = localStorage.getItem(key) || defaultValue
    }

    return value
}

export const SettingsContext = createContext({})

export const useSettingsContext = () => {
    const context = useContext(SettingsContext)

    if (!context) throw new Error('useSettingsContext must be use inside SettingsProvider')

    return context
}
